
import React, { memo } from 'react';
import { CreditCard } from 'lucide-react';
import { Switch } from "@/components/ui/switch";
import { Attendee } from '@/types/attendee';

interface PaymentToggleProps {
  attendee: Attendee;
  isPaid: boolean;
  isUpdating: boolean;
  onPaymentToggleRequest: (checked: boolean) => void;
}

const PaymentToggle: React.FC<PaymentToggleProps> = ({
  attendee,
  isPaid,
  isUpdating,
  onPaymentToggleRequest
}) => {
  return (
    <div className="flex items-center justify-end space-x-2">
      <CreditCard size={14} className={isPaid ? "text-green-500" : "text-red-500"} />
      <Switch 
        checked={isPaid} 
        onCheckedChange={(checked) => onPaymentToggleRequest(checked)}
        disabled={isUpdating}
        className={`${isPaid ? "bg-gradient-to-r from-green-400 to-emerald-500" : "bg-gradient-to-r from-red-400 to-rose-500"} shadow-md`}
        aria-label={isPaid ? "Đã thanh toán" : "Chưa thanh toán"}
      />
      <span className={`text-xs ${isPaid ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"} font-medium`}>
        {isPaid ? "Đã thanh toán" : "Chưa thanh toán"}
      </span>
    </div>
  );
};

export default memo(PaymentToggle);
